module.exports = __webpack_public_path__ + "static/media/search_global.2958d7ec.png";